import * as React from "react";

function SvgChecked(props) {
  return <svg width={20} height={18} viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.99237 18L1.718 10.1352C-0.572666 7.81871 -0.572666 4.05273 1.718 1.73849C2.82835 0.61623 4.30291 0 5.87406 0C7.42856 0 8.89422 0.60611 9.99903 1.70925C12.2941 -0.575748 16.0005 -0.567877 18.2812 1.73737C20.5729 4.05273 20.5729 7.8187 18.2812 10.1329L9.99237 18Z" fill="#E03131" /></svg>;
}

export default SvgChecked;